module.exports = __webpack_public_path__ + "img/Results-bg-image.ca809257.jpg";